export default {
	editorPanel: {
		minimizeTooltip: "minimieren",
		readOnlySuffix: "(schreibgeschützt)",
		featureModeTooltip: "Bearbeitungen für Gewinde, Senkungen usw. auswählen und einfügen/ändern",
		measuringModeTooltip: "Geometrie messen",
		weldModeTooltip: "Schweißnaht definieren",
		weldModeDisabledTooltip:
			"Dieses Material kann aktuell nicht geschweißt werden. Angaben, welche Materialien " +
			"geschweißt werden können, finden Sie unter blexon.com/werkstoffe",
		rollDirectionModeTooltip: "Schliffrichtung definieren",
		switchTopSideTooltip: "Oberseite wechseln",
		zoomToFit: "Ansicht einpassen",
		noValidationLabel: "Keine Validierung",
	},
	errorDialog: {
		closeButton: "Schliessen",
	},
	messagePanel: {
		noMessages: "Keine Meldungen",
	},
	modePanel: {
		minimizeTooltip: "minimieren",
		noModeSelected: "Es ist momentan kein Modus ausgewählt.",
	},
	sendToHelpdesk: {
		title: "Artikel an Blexon Helpdesk senden",
		introText:
			"Sie senden diesen Artikel an das Blexon Helpdesk. Wir werden die Ursache der " +
			"Fehlermeldungen prüfen und falls möglich beheben. Gerne geben wir Ihnen auch " +
			"Hinweise, wie Sie die Konstruktion ändern können, damit der Artikel herstellbar " +
			"wird. Dieser Service ist kostenlos.",
		notificationText:
			"Sie werden per E-Mail informiert, sobald der Artikel bearbeitet wurde. Die " +
			"Überprüfung erfolgt während den Geschäftszeiten in der Regel innert Stunden.",
		lockNotice:
			"Bitte beachten Sie, dass der Artikel nach dem Senden nicht mehr verändert oder " +
			"gelöscht werden kann, bis dieser von Blexon freigegeben wird.",
		emailLabel: "E-Mail für Benachrichtigungen bezüglich dieses Artikels",
		emailPlaceholder: "E-Mail Adresse hier eingeben...",
		emailRequiredError: "E-Mail muss angegeben werden.",
		emailInvalidError: "Dies ist keine gültige E-Mail Adresse.",
		submitButton: "Senden und Schließen",
		cancelButton: "Abbrechen",
	},
	unsavedChanges: {
		title: "Einige Änderungen wurden noch nicht gespeichert.",
		message: "Möchten Sie die Änderungen verwerfen?",
		discardButton: "Verwerfen",
		cancelButton: "Nein",
	},
	validationMessage: {
		showFeaturesTooltip: "Features im Modell anzeigen",
		correctTooltip: "Korrigieren",
		learnMoreLink: "Hier erfahren Sie mehr...",
		releaseCutsWarningTitle: "Freischnitt in der Biegezone erstellen",
		releaseCutsWarningText1:
			"Beim Erstellen der Freischnitte gehen vorhandene Gewinde, Senkungen, Durchzüge und " +
			"Zylinderkopfsenkungen verloren und müssen anschliessend neu definiert werden.",
		releaseCutsWarningText2:
			"Wir empfehlen, Freischnitte in der Biegezone jeweils am Anfang der Bearbeitung zu erstellen.",
		createReleaseCutsButton: "Freischnitt erstellen",
		cancelButton: "Abbrechen",
	},
	cadView: {
		gizmoRight: "Rechts",
		gizmoLeft: "Links",
		gizmoTop: "Oben",
		gizmoBottom: "Unten",
		gizmoFront: "Vorne",
		gizmoBack: "Hinten",
	},
};
